<template>
  <div class="mj_content">
    <div class="content_tabs" flex-center>
      <div class="example_show" v-if="select_tab==1">
        <div class="top_img">
          <img :src="toolList[relation].list[arrange - 1].img" alt="">
        </div>
        <div class="toolsIntroduce">

          <div class="right">
            <div>
              {{ toolList[relation].list[arrange - 1].title }}
            </div>
            <span>
               {{ toolList[relation].list[arrange - 1].guide }}
              </span>
          </div>
        </div>
      </div>
      <div class="tabs_wrap">
        <!-- select_tab=tab.type -->
        <div @click="changeTab(tab)" flex-center :class="['tabs_item',{'active':select_tab==tab.type}]"
             v-for="tab in tabs">{{ tab.name }}
        </div>
      </div>
    </div>
    <div class="content_body">
      <priceUpscaler v-if="select_tab==1&&(arrange==1&&relation==0)" :sampleList="sampleList"
                     @select_sample="selectSample" @submitForm="submitForm"></priceUpscaler>
      <priceColorize v-if="select_tab==1&&(arrange==2&&relation==0)" :sampleList="sampleList"
                     @select_sample="selectSample" @submitForm="submitForm"></priceColorize>
      <priceSharpness v-if="select_tab==1&&(arrange==3&&relation==0)" :sampleList="sampleList"
                      @select_sample="selectSample" @submitForm="submitForm"></priceSharpness>
      <pricePainting v-if="select_tab==1&&(arrange==4&&relation==0)" :sampleList="sampleList"
                     @select_sample="selectSample" @submitForm="submitForm"></pricePainting>
      <priceRemove v-if="select_tab==1&&(arrange==5&&relation==0)" :sampleList="sampleList"
                   @select_sample="selectSample" @submitForm="submitForm"></priceRemove>
      <priceBgremoval v-if="select_tab==1&&(arrange==1&&relation==1)" :sampleList="sampleList"
                      @select_sample="selectSample" @submitForm="submitForm"></priceBgremoval>
      <priceTryOn v-if="select_tab==1&&(arrange==2&&relation==1)" :sampleList="sampleList" @select_sample="selectSample"
                  @submitForm="submitForm"></priceTryOn>
      <priceHead v-if="select_tab==1&&(arrange==1&&relation==2)" :sampleList="sampleList" @select_sample="selectSample"
                 @submitForm="submitForm"></priceHead>
      <!-- 一键美颜 -->
      <OneClickBeautyTransformation v-if="select_tab==1&&(arrange==1&&relation==3)" :sampleList="sampleList" @select_sample="selectSample"
                  @submitForm="submitForm"></OneClickBeautyTransformation>
      <!-- 人物动漫化 -->
      <CharacterAnime v-if="select_tab==1&&(arrange==2&&relation==3)" :sampleList="sampleList" @select_sample="selectSample"
                  @submitForm="submitForm"></CharacterAnime>
      <!-- 人脸滤镜 -->
      <emitFacefilter v-if="select_tab==1&&(arrange==3&&relation==3)" :sampleList="sampleList" @select_sample="selectSample"
                      @submitForm="submitForm"></emitFacefilter>
      <!-- 人脸模糊(打码) -->
      <EmitBlurredfaces v-if="select_tab==1&&(arrange==4&&relation==3)" :sampleList="sampleList" @select_sample="selectSample"
                      @submitForm="submitForm"></EmitBlurredfaces>
      <!-- 发型编辑 -->
      <emitHairstyleeditor v-if="select_tab==1&&(arrange==5&&relation==3)" :sampleList="sampleList" @select_sample="selectSample"
                        @submitForm="submitForm"></emitHairstyleeditor>
      <!-- 表情编辑 -->
      <emitEmotioneditor v-if="select_tab==1&&(arrange==6&&relation==3)" :sampleList="sampleList" @select_sample="selectSample"
                           @submitForm="submitForm"></emitEmotioneditor>
      <!-- 年龄・性別变换 -->
      <emitFaceattributeediting
          v-if="select_tab==1&&(arrange==7&&relation==3)" :sampleList="sampleList" @select_sample="selectSample"
                        @submitForm="submitForm"></emitFaceattributeediting>
      <!-- 美妆 -->
      <emitFacemakeup
          v-if="select_tab==1&&(arrange==9&&relation==3)" :sampleList="sampleList" @select_sample="selectSample"
          @submitForm="submitForm"></emitFacemakeup>
      <!-- 唇色 -->
      <emitLipscolorchanger
          v-if="select_tab==1&&(arrange==10&&relation==3)" :sampleList="sampleList" @select_sample="selectSample"
          @submitForm="submitForm"></emitLipscolorchanger>
      <!-- 人脸修复增强 -->
      <emitEnhanceface
          v-if="select_tab==1&&(arrange==11&&relation==3)" :sampleList="sampleList" @select_sample="selectSample"
          @submitForm="submitForm"></emitEnhanceface>

      <msglist ref="msgList" v-if="!loading&&select_tab==2" :sampleList="sampleList"></msglist>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import priceUpscaler from 'COMPONENTS/tool/lossless/priceUpscaler.vue'
import priceColorize from 'COMPONENTS/tool/lossless/priceColorize.vue'
import priceSharpness from 'COMPONENTS/tool/lossless/priceSharpness.vue'
import pricePainting from 'COMPONENTS/tool/lossless/pricePainting.vue'
import priceBgremoval from 'COMPONENTS/tool/lossless/priceBgremoval.vue'
import priceHead from 'COMPONENTS/tool/lossless/priceHead.vue'
import priceRemove from 'COMPONENTS/tool/lossless/priceRemove.vue'
import priceTryOn from 'COMPONENTS/tool/lossless/priceTryOn.vue'
import Msglist from 'COMPONENTS/tool/Msglist'
import OneClickBeautyTransformation from "COMPONENTS/tool/lossless/oneClickBeautyTransformation.vue";
import CharacterAnime from "COMPONENTS/tool/lossless/characterAnime.vue";
import emitFacefilter from "COMPONENTS/tool/lossless/emitFacefilter.vue";
import EmitBlurredfaces from "COMPONENTS/tool/lossless/emitBlurredfaces.vue";
import emitHairstyleeditor from "COMPONENTS/tool/lossless/emitHairstyleeditor.vue";
import emitEmotioneditor from "COMPONENTS/tool/lossless/emitEmotioneditor.vue";
import emitFaceattributeediting from "COMPONENTS/tool/lossless/emitFaceattributeediting.vue";
import emitFacemakeup from "COMPONENTS/tool/lossless/emitFacemakeup.vue";
import emitLipscolorchanger from "COMPONENTS/tool/lossless/emitLipscolorchanger.vue";
import emitEnhanceface from "COMPONENTS/tool/lossless/emitEnhanceface.vue";


export default {
  components: {
    emitEnhanceface,
    emitLipscolorchanger,
    emitFacemakeup,
    emitFaceattributeediting,
    emitEmotioneditor,
    emitHairstyleeditor,
    EmitBlurredfaces,
    emitFacefilter,
    CharacterAnime,
    OneClickBeautyTransformation,
    Msglist,
    priceUpscaler,
    priceColorize,
    priceSharpness,
    pricePainting,
    priceBgremoval,
    priceHead,
    priceRemove,
    priceTryOn
  },
  data() {
    return {
      tabs: [{name: "创作中心", type: 1}, {name: "生成记录", type: 2}],
      select_tab: 1,
      sampleList: [],
      loading: true,
      arrange: '',
      relation: '',
      toolList: [
        {
          title: '图片编辑', relation: 0, list: [
            {
              id: 1,
              relation: 0,
              name: '极速高清无损放大',
              guide: '无损放大图片，支持2倍、3倍、4倍放大，有效改善放大后图像的噪点与锯齿问题。',
              img: require('../img/magnify.png'),
              title: '无损放大',
            },

            {
              id: 2,
              relation: 0,
              name: '黑白图像上色',
              guide: '通过人工智能算法，识别黑白图像内容并填充色彩，使黑白图像变得鲜活。',
              img: require('../img/colour.png'),
              title: '黑白上色',
            },
            {
              id: 3,
              relation: 0,
              name: '图像清晰度增强',
              guide: '利用Ai技术，智能识别图像主体以消除模糊，增强对比度和颜色，获得更清晰、更生动的视觉效果。',
              img: require('../img/repair.png'),
              title: '清晰增强',
            },
            {
              id: 4,
              relation: 0,
              name: '图像风格转换',
              guide: '您可以将图像转换为卡通、铅笔、彩色铅笔或哥特式油画等多种风格。',
              img: require('../img/cartoon.png'),
              title: '风格转换',
            },
            {
              id: 5,
              relation: 0,
              name: '图像擦除',
              guide: '快速移除照片中不需要的的物、人、文字。清理照片，美化图片',
              img: require('../img/removelog.png'),
              title: '图像擦除',
            },

          ],
        },
        {
          title: '电商设计', relation: 1, list: [
            {
              id: 1,
              relation: 1,
              name: '背景移除',
              guide: '智能地识别图像的主体，将其视为前景并自动去除背景。适用于各种场景中的人物、动物等。',
              img: require('../img/capture.png'),
              title: '背景移除',
            },
            {
              id: 2,
              relation: 1,
              name: 'AI虚拟试衣  ',
              guide: '一键智能扩图，也可以对图片进行上下左右自定义像素的自动填充',
              img: require('../img/fittingRoom.jpg'),
              title: 'AI虚拟试衣 ',
            },

          ],
        },
        {
          title: '创意应用', relation: 2, list: [
            {
              id: 1,
              relation: 2,
              name: '头像提取',
              guide: '它能够准确检测头部区域，一键裁剪并去除其他元素。',
              img: require('../img/expansion.png'),
              title: '头像提取',
            },

          ],
        },

        {
          title: 'AI变美', relation: 3, list: [
            {
              id: 1,
              relation: 3,
              name: '照片一键美颜',
              title: '照片一键美颜',
              mj_tool: 'oneClickBeautyTransformation',
              guide: '利用AI技术，实现完整的肖像增强，包括皮肤平滑、美白、脸部瘦身等，以达到自然的外观',
              img: require('../img/beautify1.webp'),
              points: 1,
            },
            {
              id: 2,
              relation: 3,
              name: '人物动漫化',
              title: '人物动漫化',
              mj_tool: 'characterAnime',
              guide: '利用先进的AI技术将完整图像或照片转化为卡通或动漫效果，非常适合创建卡通化照片和卡通风格的虚拟形象',
              img: require('../img/beautify2.webp'),
              points: 1,
            },
            {
              id: 3,
              relation: 3,
              name: '人脸滤镜',
              title: '人脸滤镜',
              mj_tool: 'emitFacefilter',
              guide: '智能识别图像内容，快速应用AI滤镜，提升图像质感，支持滤镜强度调节，轻松优化视觉效果',
              img: require('../img/beautify3.webp'),
              points: 1,
            },
            {
              id: 4,
              relation: 3,
              name: '人脸模糊(打码)',
              title: '人脸模糊(打码)',
              mj_tool: 'emitBlurredfaces',
              guide: '利用先进的AI技术，智能识别人脸区域，一键模糊人脸，轻松保护隐私，提升图像安全性',
              img: require('../img/beautify4.webp'),
              points: 1,
            },
            {
              id: 5,
              relation: 3,
              name: '发型编辑',
              title: '发型编辑',
              mj_tool: 'emitHairstyleeditor',
              guide: '能够精准识别人像区域，实现一键更换发型和发色。您可以选择多达数十种发型和发色组合，轻松打造您独特的个性化造型，满足不同的美发需求',
              img: require('../img/beautify5.webp'),
              points: 1,
            },
            {
              id: 6,
              relation: 3,
              name: '表情编辑',
              title: '表情编辑',
              mj_tool: 'emitEmotioneditor',
              guide: '无论是闭嘴微笑、露齿笑、嘟嘴、还是耍酷或悲伤等十多种表情，您都可以轻松生成自然逼真的效果',
              img: require('../img/beautify6.webp'),
              points: 1,
            },
            {
              id: 7,
              relation: 3,
              name: '年龄・性別变换',
              title: '年龄・性別变换',
              mj_tool: 'emitFaceattributeediting',
              guide: '采用先进的AI技术，智能识别人脸，实现从15岁到85岁的年龄变换，以及男性与女性之间的性别转换',
              img: require('../img/beautify7.webp'),
              points: 1,
            },
            {
              id: 8,
              relation: 3,
              name: '人脸美颜',
              title: '人脸美颜',
              mj_tool: 'emitFacebeauty',
              guide: '拥有美白和光滑皮肤等美化特性，以及面部塑形。此外，它还提供了多种滤镜，以增强您的图像并增添艺术气息。',
              img: require('../img/beautify8.webp'),
              points: 1,
            },
            {
              id: 9,
              relation: 3,
              name: '人脸美妆',
              title: '人脸美妆',
              mj_tool: 'emitFacemakeup',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('../img/beautify9.webp'),
              points: 1,
            },
            {
              id: 10,
              relation: 3,
              name: '唇色变换器',
              title: '唇色变换器',
              mj_tool: 'emitLipscolorchanger',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('../img/beautify10.webp'),
              points: 1,
            },
            {
              id: 11,
              relation: 3,
              name: '人脸修复增强',
              title: '人脸修复增强',
              mj_tool: 'emitEnhanceface',
              guide: '自动去除图像中的模糊部分，提升脸部的清晰度和细节。通过AI处理，您可以轻松优化面部图像的质量，使其更加清晰、自然',
              img: require('../img/beautify11.webp'),
              points: 1,
            },
          ],
        },

      ],
    }
  },
  created() {

    this.arrange = this.$route.query.arrange
    this.relation = this.$route.query.relation
    this.fettchSampleList();
    console.log('arrange', this.arrange)
    console.log('relation', this.relation)
  },
  methods: {
    changeTab(tab) {
      this.select_tab = tab.type
      let boxsty = document.querySelector('.tool_page')
      if (this.select_tab == 2) {
        boxsty.style.height = 'calc(100% - 40px)'
      } else {
        boxsty.style.height = 'calc(100% - 110px)'
      }
    },
    fettchSampleList() {
      // 获取样例数据
      this.$http.get('/front/aimj/draw/sample/', {params: {max_mj_id: this.max_mj_id}}).then((res) => {
        this.sampleList = res.data.item_list;
        this.loading = false;
      })
    },
    selectSample(item) {
      // this.$refs.msgList.choose_tips_item(item);
      console.log('selectSample>11111111')
      this.select_tab = 2
    },
    submitForm(data) {
      console.log("this.$refs.msgList=", this.$refs.msgList)
      this.select_tab = 2
      // this.$refs.msgList.submitQuestion(data);
    },

  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.mj_content {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-shrink: 0;

  .content_tabs {
    width: 100%;
    border-bottom: 1px solid #26282c;
    padding: 5px 0;
    display: flex;
    flex-direction: column;

    .example_show {
      width: 100%;
      padding: 0 10px;

      .top_img {
        width: 100%;
        border-radius: 10px;
        overflow: hidden;

        img {
          aspect-ratio: auto 16 / 9;
          width: 100%;
          vertical-align: middle;
          object-fit: cover;
          -webkit-user-drag: none;
        }
      }

      .toolsIntroduce {
        background-color: #1e1f22;
        padding: 10px 14px;
        display: flex;
        border-radius: 5px;
        margin: 5px 0;

        .right {
          word-break: break-all !important;
          font-size: 12px;
          line-height: 20px;
          white-space: normal;

          div {
            font-size: 14px;
            font-weight: 700;
            height: 20px;
            margin-bottom: 5px;
          }

          span {
            font-size: 12px;
            line-height: 20px;
          }

        }
      }
    }

    .tabs_wrap {
      width: 210px;
      padding: 3px;
      color: #fff;
      background-color: #292929;
      display: flex;
      justify-content: space-between;
      border-radius: 999px;

      .tabs_item {
        height: 31px;
        width: 100px;
        border-radius: 999px;

        &.active {
          font-weight: 700;
          background-color: #5865f2;
        }
      }
    }
  }

  .content_body {
    height: calc(100% - 48px);
    overflow-y: auto;
    background-color: #1d2027;
    //overflow: hidden;
    //flex: 1 1 0%;
    white-space: nowrap;
    text-overflow: ellipsis;

  }
}
</style>